import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getMisc } from "../../../apiclients/streamsapi_bridge";
import AARoutDest from "./AARoutDest";
import { useFieldArray, useFormContext } from "react-hook-form";
import BusyNoAnswerRoute from "../editUtils/BusyNoAnswerRoute";
import RouteCalls from "../../RouteCalls"; // ← NEW unified component

const AARouting = ({
  destinationTypes,
  serverError,
  newRouteFlag,
  setNewRouteFlag,
  aagcode,
  settingInfoFlag,
  fields,
  assocCallFlows,
  setIsloading,
}) => {
  const {
    register,
    setValue,
    formState: { errors },
    setError,
    clearErrors,
    reset,
    control,
  } = useFormContext();

  const { t, i18n } = useTranslation();
  const [AddNumbers, setAddNumbers] = useState(false);
  const toggleShow12 = () => setAddNumbers(!AddNumbers);
  const [data, setData] = useState([]);
  const [defaultData, setDefaultData] = useState({});
  const [displayValuess, setDisplayValuess] = useState([]);
  const [newRoutings, setNewRoutings] = useState([]);
  const [pressid, setPressId] = useState(-1);
  const [updateDest, setUpdateDest] = useState({});
  const [isUpdateDest, setIsUpdateDest] = useState(false);
  const [timeoutFlag, setTimeOutFalg] = useState(false);
  const [cidPassThrough, setCIDPassThrough] = useState(true);
  const [timeOut, setTimeOut] = useState(0);
  const [callerid, setCallerId] = useState("");
  const [callerList, setCallerList] = useState([]);

  useEffect(() => {
    if (newRouteFlag) {
      setNewRoutings([]);
      setNewRouteFlag(false);
    }
  }, [newRouteFlag]);
  async function fetchAAMiscData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["aaMiscInfo"] }
    );
    if (!response.json) return;
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id not found`);
      return;
    }

    const userList = tdata?.misc?.aaMiscInfo?.user ?? [];
    let groupList = tdata?.misc?.aaMiscInfo?.group ?? [];
    groupList = groupList.filter(
      (group) => group.code && parseInt(group.code) !== parseInt(aagcode)
    )?.filter((group) => group.category !== "ACD");
    // const hggroupList = groupList.filter(
    //   (group) => group.category !== "Auto-Attendant"
    // );
    // const aagroupList = groupList.filter(
    //   (group) => group.category === "Auto-Attendant"
    // );
    groupList = groupList.sort((a, b) => a?.title?.localeCompare(b?.title));

    const callerlists = tdata?.misc?.aaMiscInfo?.cid_pass ?? [];
    const voicemailList = tdata?.misc?.aaMiscInfo?.voicemail ?? {};
    const userVoicemailList = tdata?.misc?.aaMiscInfo?.user_voicemails ?? [];

    let groupVoicemailList = (tdata?.misc?.aaMiscInfo?.group_voicemails ?? [])?.filter((group) => group.category !== "ACD Group-Voicemail");
    // groupVoicemailList = groupVoicemailList.filter(
    //   (list) => list.category !== "Auto-Attendant-Voicemail"
    // );

    const voicemails = [...userVoicemailList, ...groupVoicemailList]
      ?.sort((a, b) => a?.title?.localeCompare(b?.title))
      ?.map((item) => ({
        ...item,
        category: item.category.replace(/-Voicemail$/, ""),
      }));

    const operators = tdata?.misc?.aaMiscInfo?.operator ?? {};
    const dialByName = tdata?.misc?.aaMiscInfo?.dialby_name ?? {};

    const listObj = {
      user: userList,
      hggroup: groupList,
      voicemail: voicemailList,
      userVoicemail: voicemails,
      operators,
      dialByName,
    };
    setDefaultData(listObj);
    setCallerList(callerlists);
  }

  useEffect(() => {
    if (aagcode !== "") {
      fetchAAMiscData();
    }
  }, [aagcode]);

  return (
    <>
      <div className="routing-border"></div>

      <div className="card-header p-2" id="routing">
        <h5 className="mb-0">
          <div className="general-settings" id="general">
            {t("routing")}
          </div>
        </h5>
        <span className="phrecording">{t("routingtxt")}</span>
      </div>

      {fields &&
        fields.length > 0 &&
        fields.map((field, index) => {
          // Build per-row field name map so RouteCalls writes to the correct
          // array slot in the form state.
          const aaFieldNames = {
            destinationType: `routing[${index}].destination_type`,
            destinationvalue: `routing[${index}].value`,
            entityType: `routing[${index}].entity_type`,
            ph_num: `routing[${index}].phnumber`,
            timeout: `routing[${index}].timeout`,
            timeoutFlag: `routing[${index}].timeout_flag`,
            timeoutrouting: `routing[${index}].timeout_routing`,
            timeoutdesttyperouting: `routing[${index}].timeout_dest_type`,
            cidPassFlag: `routing[${index}].cid_pass_flag`,
            cidPass: `routing[${index}].cid_pass`,
          };

          return (
          <div key={field.id} className="routing-border p-0 mb-0 mt-3">
            <div className="add-numbermain">
              <div className="tel-numbers">
                {t("press")}{" "}
                {field.command === 35
                  ? "*"
                  : field.command === 42
                  ? "#"
                  : field.command}
              </div>
                <div className="w-30 sm-w-40">
                  {/*
                    ── OLD BusyNoAnswerRoute (kept, commented out) ──
                <BusyNoAnswerRoute
                  operatorsList={defaultData}
                  operatorValue={field.operatorValue}
                  CallerList={callerList}
                  executeSetting={false}
                  aaFlag={true}
                  command={field.command}
                  assocCallFlows={assocCallFlows}
                  setIsloading={setIsloading}
                  mainLabel="Select Destination"
                  mainRouteError="Please Select Destination"
                  fieldNames={{
                    destinationType: `routing[${index}].destination_type`,
                    destinationvalue: `routing[${index}].value`,
                    entityType: `routing[${index}].entity_type`,
                    ph_num: `routing[${index}].phnumber`,
                    timeout: `routing[${index}].timeout`,
                    timeoutFlag: `routing[${index}].timeout_flag`,
                    timeoutrouting: `routing[${index}].timeout_routing`,
                    timeoutdesttyperouting: `routing[${index}].timeout_dest_type`,
                    cidPassFlag: `routing[${index}].cid_pass_flag`,
                    cidPass: `routing[${index}].cid_pass`,
                  }}
                />
                  */}

                  {/* ── NEW unified RouteCalls ── */}
                  <RouteCalls
                    destRecords={defaultData}
                    callerList={callerList}
                    command={field.command}
                    fieldNames={aaFieldNames}
                    routeDetails={field.operatorValue}
                    executeSetting={false}
                    setIsloading={setIsloading}
                    mainLabel="Search and Select Destination"
                    mainRouteError="Please Select Destination"
                    aaFlag={true}
                  />
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default AARouting;
